<template>
  <div class="app-wrapper">
    <left
      :theme="store.state.theme"
      :collapsed="collapsed"
      :parentId="parentId"
      @flag="flagMarginLeft"
      :changeMenu="changeMenu"
    ></left>
    <!-- class="main-container" -->
    <div :class="{ ml: flagClone }">
      <div :class="{ empt: !flagClone }" ref="myRef">
        <top
          :theme="store.state.theme"
          :collapsed="collapsed"
          @setValue="setValue"
        ></top>
        <app-main ref="mychild"></app-main>
      </div>
    </div>
  </div>
</template>

<script>
import top from "./menu/top";
import left from "./menu/left";
import AppMain from "./menu/AppMain";
import { useStore } from "vuex";
import { ref, provide, inject, computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "layout",
  components: {
    top,
    left,
    AppMain,
  },
  setup() {
    const store = useStore();
    let collapsed = ref(false);
    let route = useRoute();
    let myRef = ref(null);
    let changeMenu = ref(null);
    const toggleCollapsed = () => {
      collapsed.value = !collapsed.value;
    };

    const changeTheme = () => {
      store.commit("setTheme", !store.state.theme);
    };

    provide("changeTheme", changeTheme);
    provide("toggleCollapsed", toggleCollapsed);
    let parentId = ref(1);

    const setValue = (val) => {
      changeMenu.value = val.val;
      // console.log(val.val);
      parentId.value = Number(val.val);
    };
    let flagClone = ref(false);
    let flagMarginLeft = (flag) => {
      flagClone.value = flag;
    };
    // onMounted(() => {
    //   if (route.path === "/home/index" && flagClone.value == false) {
    //     myRef.value.style.marginLeft = "136px";
    //     // console.log(myRef.value.style);
    //   } else if (route.path === "/home/index" && flagClone.value == true) {
    //     myRef.value.style.marginLeft = "300px";
    //   }
    // });

    return {
      changeMenu,
      flagClone,
      flagMarginLeft,
      store,
      collapsed,
      toggleCollapsed,
      changeTheme,
      setValue,
      parentId,
      myRef,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-container {
  background: #304156;
}
.ml80 {
  margin-left: 136px;
}
.empt {
  margin-left: 277px;
  // margin-left: 138px;
}
.main-container {
  margin-left: 136px !important;
}
.ml {
  margin-left: 136px;
}
</style>
